// extracted by mini-css-extract-plugin
export var container = "_5w-0";
export var error = "_5w-9";
export var label = "_5w-5";
export var light = "_5w-6";
export var md = "_5w-3";
export var sm = "_5w-2";
export var thin = "_5w-8";
export var thinBold = "_5w-7";
export var vertical = "_5w-4";
export var xs = "_5w-1";